/**
 * handleDelete.js
 *
 * Copyright (c) apploft. GmbH
 */

import {http, URL, APIDefinition, HTTPError} from 'apploft-cloud-client';
import {submittingForm} from '../ContentStateSymbol';
import {
  formResponseReceived,
  failedFormSubmission,
} from '../ContentEventSymbol';

/**
 * Returns `true` if it’s better to tolerate the error, not reporting it to
 * our users. For example, a 404 if they wanted to delete something.
 *
 * @param {HTTPError} error
 */
function shouldTolerate({status}) {
  return status === 404;
}

export default function handleDelete(
  {section, api},
  {item: {objectId}, formData, dispatch},
) {
  const paths = APIDefinition.pathsMatching(section, api);
  const url = URL.createDeleteUrl({api, paths, objectId});
  const authorization = APIDefinition.keyAdminAuth(api);
  const controller = new AbortController();

  const {signal} = controller;
  const {del} = http;

  // Assuming we are reloading the list in the success case, we can ignore
  // the response here.

  del({url, authorization, signal})
    .then(res => {
      dispatch({
        event: formResponseReceived,
        payload: {section, api, dispatch},
      });
    })
    .catch(error => {
      if (error instanceof DOMException) {
        console.assert(
          error.message === 'The user aborted a request.',
          `unexpected error: ${error.message}`,
        );

        return;
      }

      if (error instanceof HTTPError) {
        if (shouldTolerate(error)) {
          dispatch({
            event: formResponseReceived,
            payload: {section, api, dispatch},
          });

          return;
        }
      }

      dispatch({event: failedFormSubmission, payload: error});
    });

  return {
    state: submittingForm,
    data: {section, api, formData},
    controller,
  };
}
